// 💾 /src/pages/public/Profile.tsx
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { auth, db } from "../../../../../services/firebase"
import { doc, getDoc } from "firebase/firestore"
import "./style/Profile.scss"
import profileIcon from "../../../../../assets/images/userProfileIcon.png"
import { useTranslation } from "react-i18next"

type MockBalance = {
  id: string
  amount: number
  eurRate?: number
}

const Profile: React.FC = () => {
  const [balanceUSDT, setBalanceUSDT] = useState<number>(0)
  const [balanceEUR, setBalanceEUR] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>("")
  const [user, setUser] = useState(auth.currentUser)
  const [status, setStatus] = useState("loading") // "Verified" | "notVerified" | "loading"
  const { t } = useTranslation()

  useEffect(() => {
    const fetchData = async () => {
      const u = auth.currentUser
      if (!u) {
        setError("User not signed in")
        setLoading(false)
        return
      }
      setUser(u)

      try {
        // 1. Get verification status (still from Firestore)
        const userRef = doc(db, "users", u.uid)
        const userSnap = await getDoc(userRef)
        const status = userSnap.exists() ? userSnap.data().status : "notVerified"
        setStatus(status)

        // 2. Try to load mock balance for this user
        let usdt = 0
        let eurValue = 0

        try {
  const resp = await fetch("/mockBalances.json")
  const mockList: MockBalance[] = await resp.json()
  console.log("Mock list:", mockList)   // 👈 log the whole file
  console.log("Current UID:", u.uid)    // 👈 log current user uid

  const mock = mockList.find(m => m.id === u.uid)
  console.log("Found mock entry:", mock) // 👈 log result

  if (mock) {
    usdt = mock.amount
    eurValue = mock.eurRate ?? 0
  } else {
    usdt = 0
    eurValue = 0
  }
} catch (jsonErr) {
  console.warn("Mock balances not available:", jsonErr)
  usdt = 0
  eurValue = 0
}


        setBalanceUSDT(usdt)
        setBalanceEUR(eurValue)
      } catch (e) {
        console.error("Profile fetch error", e)
        setError("Failed to load balances")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return (
    <div className="profile-tab">
      {/* 🔔 NOT VERIFIED BANNER */}
      {status !== "Verified" && status !== "loading" && (
        <div className="alert alert-warning">
          Your account is not verified.{" "}
          <Link to="/en/verify" className="verify-link">
            Please click here to verify your account.
          </Link>
        </div>
      )}

      <div className="user-card">
        <div className="avatar"><img src={profileIcon} /></div>
        <div className="info">
          <div className="name">
            {user?.displayName || "Set Nickname"}{" "}
            {status === "Verified" ? (
              <span className="badge verified">{t("profile.verified")}</span>
            ) : (
              status !== "loading" && (
                <span className="badge not-verified">{t("profile.notVerifiedBadge")}</span>
              )
            )}
          </div>
          <div className="grid">
            <div>
              <strong>{t("profile.account")}:</strong> {user?.email || "—"}
            </div>
            <div>
              <strong>{t("profile.uid")}:</strong> {user?.uid || "—"}
            </div>
            <div>
              <strong>{t("profile.signupTime")}:</strong>{" "}
              {user?.metadata.creationTime
                ? new Date(user.metadata.creationTime).toLocaleString()
                : "—"}
            </div>
            <div>
              <strong>{t("profile.lastLogin")}:</strong>{" "}
              {user?.metadata.lastSignInTime
                ? new Date(user.metadata.lastSignInTime).toLocaleString()
                : "—"}
            </div>
          </div>
        </div>
      </div>

      <div className="asset-card">
        <h3>{t("profile.totalValue")}</h3>

        {loading ? (
          <div className="loading">{t("profile.loadingBalances")}</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : (
          <>
            <div className="balance">
              {balanceUSDT.toFixed(2)} <span>USDT</span>
            </div>
            <div className="balance-eur">
              ≈ {balanceEUR.toFixed(2)} <span>EUR</span>
            </div>
          </>
        )}

        <button className="deposit-btn">{t("profile.deposit")}</button>
      </div>

      <div className="widget-cards">
        <div className="widget">
          <h4>🎁 {t("profile.referralTitle")}</h4>
          <p>{t("profile.referralDesc")}</p>
          <input
            type="text"
            value={`https://myexch.com/signup?ref=${user?.uid}`}
            readOnly
          />
        </div>

        <div className="widget">
          <h4>📘 {t("profile.learnTitle")}</h4>
          <p>{t("profile.learnDesc")}</p>
        </div>
      </div>
    </div>
  )
}

export default Profile
